export default __webpack_public_path__ + "static/media/team.7bc26c79.svg";